export const FETCH_USER_STATS = 'FETCH_USER_STATS'
export const FETCH_USER_STATS_LOADING = 'FETCH_USER_STATS_LOADING'
export const FETCH_USER_STATS_ERROR = 'FETCH_USER_STATS_ERROR'
export const FETCH_USER_STATS_SUCCESS = 'FETCH_USER_STATS_SUCCESS'

export const FETCH_LIFETIME_STATS = 'FETCH_LIFETIME_STATS'
export const FETCH_LIFETIME_STATS_LOADING = 'FETCH_LIFETIME_STATS_LOADING'
export const FETCH_LIFETIME_STATS_ERROR = 'FETCH_LIFETIME_STATS_ERROR'
export const FETCH_LIFETIME_STATS_SUCCESS = 'FETCH_LIFETIME_STATS_SUCCESS'



// WEBPACK FOOTER //
// ./src/services/userStats/constants.js